// Generated by genversion.
module.exports = '5.1055.12';
